import React from 'react';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

const ListActions = ({ newItemPath, isReadonly, t }) => {
	return (
		<div className={isReadonly ? 'hidden' : ''}>
			<Link to={newItemPath} className='btn btn-success'>{t('Common_New')}</Link>
		</div>
	);
};

export default withTranslation()(ListActions);